import { useState } from 'react';
import { DatePicker, DatePickerInput } from '@carbon/react';

export default function Calendar({ setDate }: any) {

  const change = (value: any) => {
    setDate(value[0])
  }

  return (<>
    <div className="c-calendar">
      <DatePicker
        dateFormat="m/d/Y"
        datePickerType="single"
        onChange={change}
        className='calendar'
      >
        <DatePickerInput
          short={true}
          id="date-picker-calendar-id"
          placeholder="mm/dd/yyyy"
          type="text"
        />
      </DatePicker>
    </div>
  </>)
}